<template>
  <div class="sub-header">
    <div class="sub-header__wrap container flex">
      <h1 class="sub-header__title main-title ">Водители</h1>
      <div class="sub-header__right">
        <p class="sub-header__text"> {{ from }} - {{ to }} из {{ count }}</p>
        <button :disabled="pageNumber == 1" class="sub-header__box" @click="prevPage()">
          <img v-if="pageNumber == 1" class="sub-header__box-icon" src="@/assets/png/database-icon.png" />
          <img v-else class="sub-header__box-icon" src="@/assets/png/database-icon-active.png" alt="" style="transform: rotate(180deg)"/>
        </button>
        <button :disabled="count <= to" class="sub-header__box"  @click="nextPage()">
          <img  v-if="count > to" class="sub-header__box-icon" src="@/assets/png/database-icon-active.png" alt=""/>
          <img  v-else class="sub-header__box-icon" src="@/assets/png/database-icon.png" alt="" style="transform: rotate(180deg)"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props:{
    drivers : {
      type: Array,
      default: null
    },
    pageNumber: {
      type: Number,
      default: 1
    },
    count: {
      type: Number,
      default: 1
    }
  },  
  data() {
    return {
      title: "",
      showBlock: false,
      from: 0,
      to : 0
    };
  },
  methods:{
      nextPage(){
        this.$emit('nextPage');
        this.from = this.from + 10;
        this.to = this.to + 10; 
        if(this.to > this.count ){
          this.to = this.count;
        }
      },
      prevPage(){
        this.$emit('prevPage');
        this.from = this.from - 10;
        if(this.to == this.count){
          this.to = this.from + 9;
        }else{
          this.to = this.to - 10;
        }
      }
  },
  mounted() {
    this.from = this.pageNumber 
    this.to = this.pageNumber + 9
  },
  watch: {
    drivers: function(){
      if(this.drivers.length < 10){
        this.to = this.count
      }else{
        // this.to = (this.pageNumber * 9) + 9
      }
    }
  },
};
</script>

<style scoped>
.sub-header {
  background-color: #fff;
  /* box-sizing: border-box; */
  height: 70px;
}
.sub-header__right {
  display: inline-block;
}

.sub-header__title {
  font-weight: 500;
  font-size: 36px;
  line-height: 46px;
}
.sub-header__text {
  margin: 30px 20px 0 25px;
  color: #707070;
  display: inline-block;
}

.sub-header__box {
  min-width: 36px;
  height: 36px;
  line-height: 16px;
  background: #ffffff;
  border: 1px solid #e0e9fa;
  box-sizing: border-box; 
  border-radius: 8px;
}
.sub-header__box:not(:last-child) {
  margin-right: 18px;
}
</style>
